import { render, staticRenderFns } from "./BaseDashboardInfoCard.vue?vue&type=template&id=47939e29&scoped=true&"
import script from "./BaseDashboardInfoCard.vue?vue&type=script&lang=js&"
export * from "./BaseDashboardInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseDashboardInfoCard.vue?vue&type=style&index=0&id=47939e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47939e29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VIcon,VSimpleTable})
